import React from 'react';
import { aiProjects } from '../data/portfolio';
import { AIProject } from '../types';
import './scss/AIAutomation.scss';

const AIAutomation: React.FC = () => {
  return (
    <section id="ai-automation" className="ai-automation">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">AI Automation & Innovation</h2>
          <p className="section-subtitle">
              Designing secure AI platforms and RAG-based LLM solutions that connect business context, knowledge retrieval, and practical automation
          </p>
        </div>

        <div className="ai-projects-grid">
          {aiProjects.map((project: AIProject) => (
            <div key={project.id} className="ai-project-card">
              <div className="project-icon">
                <i className={project.icon}></i>
              </div>
              
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                
                <div className="project-features">
                  <h4>Key Features:</h4>
                  <ul>
                    {project.features.map((feature: string, index: number) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>

                <div className="project-technologies">
                  <h4>Technologies:</h4>
                  <div className="tech-tags">
                    {project.technologies.map((tech: string, index: number) => (
                      <span key={index} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>

                {project.capabilities && (
                  <div className="project-capabilities">
                    <h4>AI Capabilities:</h4>
                    <div className="capabilities-list">
                      {project.capabilities.map((capability: string, index: number) => (
                        <div key={index} className="capability-item">
                          <i className="fas fa-check-circle"></i>
                          <span>{capability}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {project.metrics && (
                  <div className="project-metrics">
                    <h4>Performance Metrics:</h4>
                    <div className="metrics-grid">
                      {project.metrics.map((metric, index: number) => (
                        <div key={index} className="metric-item">
                          <span className="metric-value">{metric.value}</span>
                          <span className="metric-label">{metric.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="ai-skills-showcase">
            <h3>AI, Data & Platform Expertise</h3>
          <div className="ai-skills-grid">
            <div className="ai-skill-category">
              <h4><i className="fas fa-brain"></i> Natural Language Processing</h4>
              <ul>
                  <li>Context Management & Knowledge Retrieval</li>
              </ul>
            </div>
            
            <div className="ai-skill-category">
              <h4><i className="fas fa-database"></i> Data Engineering</h4>
              <ul>
                  <li>Vector Search & Knowledge Stores</li>
                <li>Data Pipeline Architecture</li>
                <li>Real-time Stream Processing</li>
                <li>ETL/ELT for ML Workflows</li>
              </ul>
            </div>
            
            <div className="ai-skill-category">
              <h4><i className="fas fa-robot"></i> AI Integration</h4>
              <ul>
                  <li>LLM Integrations</li>
                  <li>Azure Cognitive Services</li>
                  <li>Secure AI Platform Architecture</li>
                  <li>REST API and OpenAPI Design</li>
              </ul>
            </div>
            
            <div className="ai-skill-category">
              <h4><i className="fas fa-chart-line"></i> Analytics & Insights</h4>
              <ul>
                  <li>RAG Application Design</li>
                  <li>Data Integration Pipelines</li>
                  <li>Monitoring and Governance</li>
                  <li>Enterprise Knowledge Management</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIAutomation;
